import React from 'react';
import { getPrimary, getSecondary } from '../../styles/colors';
import {
	AlertConfirm, BasicButton, Radio, TextInput
} from '../../UI';

const randomKey = Math.random().toString(10).substr(2, 2);

const getInputConfig = type => {
	const basicConfig = {
		label: '',
		name: `labelCustom_${randomKey}`,
		text: {
			es: '',
			en: '',
			gal: '',
			cat: '',
			eu: '',
			fr: '',
			pt: '',
			pl: ''
		},
		type,
		valueType: 'text',
		value: '',
		isActive: true,
		isCustom: true,
		required: false,
		confirm: false,
		checkbbdd: false
	};

	if (['radio', 'select'].includes(type)) {
		return {
			...basicConfig,
			items: [],
		};
	}

	if (type === 'checkbox') {
		return {
			...basicConfig,
			items: [],
			maxSelections: 1,
			minSelections: 1,
			uniqueValues: [],
		};
	}

	if (type === 'textarea') {
		return {
			...basicConfig,
			maxSize: 2000
		};
	}

	return basicConfig;
};

const ModalNewInput = ({
	translate,
	setLocalState,
	input,
	isDuplicatedName,
	label,
}) => {
	const [newMain, setNewMain] = React.useState(false);
	const [newInput, setNewInput] = React.useState(input);
	const [type, setType] = React.useState('text');
	const [error, setError] = React.useState({});

	React.useEffect(() => {
		setNewInput(input);
	}, [input]);

	React.useEffect(() => setNewInput(getInputConfig(type)), [type]);

	const emptyError = 'El valor no puede estar vacío';
	const duplicatedError = 'El valor ya está en uso';
	const incorrectValueError = 'El valor es incorrecto';
	const maxLessThanMinError = 'El valor no puede ser menor al mínimo';
	const minMoreThanMaxError = 'El valor no puede ser mayor al máximo';

	const inputTypes = [
		{
			label: 'Texto',
			value: 'text'
		},
		{
			label: 'Textarea',
			value: 'textarea'
		},
		{
			label: 'Checkbox',
			value: 'checkbox'
		},
		{
			label: 'Radio buttons',
			value: 'radio'
		},
		{
			label: 'Teléfono',
			value: 'phone'
		},
		{
			label: 'Selección',
			value: 'select'
		},
	];

	const valueTypes = [
		{
			label: 'Texto',
			value: 'text'
		},
		{
			label: 'Numero',
			value: 'number'
		},
		{
			label: 'Booleano',
			value: 'boolean'
		},
	];

	const setName = name => {
		setNewInput({
			...newInput,
			name
		});
		// Empty name
		if (!name) {
			setError({
				...error,
				name: emptyError
			});
			return;
		}
		// Duplicated name
		if (isDuplicatedName(name)) {
			setError({
				...error,
				name: duplicatedError
			});
			return;
		}
		const newError = error;
		delete newError.name;
		setError(newError);
	};

	const setMaxSelections = maxSelections => {
		setNewInput({
			...newInput,
			maxSelections: maxSelections || 0
		});
		// Empty name
		if (!maxSelections || maxSelections < 1) {
			setError({
				...error,
				maxSelections: incorrectValueError
			});
			return;
		}
		// Max selections is less than min selections
		if (maxSelections < newInput?.minSelections) {
			setError({
				...error,
				maxSelections: maxLessThanMinError
			});
			return;
		}
		const newError = error;
		delete newError.maxSelections;
		setError(newError);
	};

	const setMinSelections = minSelections => {
		setNewInput({
			...newInput,
			minSelections: minSelections || 0
		});
		// Empty name
		if (!minSelections || minSelections < 1) {
			setError({
				...error,
				maxSelections: incorrectValueError
			});
			return;
		}
		// Min selections is more than max selections
		if (minSelections > newInput?.maxSelections) {
			setError({
				...error,
				maxSelections: minMoreThanMaxError
			});
			return;
		}
		const newError = error;
		delete newError.maxSelections;
		setError(newError);
	};

	const setMaxSize = maxSize => {
		setNewInput({
			...newInput,
			maxSize: maxSize || 0
		});
		// Empty name
		if (!maxSize || maxSize < 1) {
			setError({
				...error,
				maxSize: incorrectValueError
			});
			return;
		}
		const newError = error;
		delete newError.maxSize;
		setError(newError);
	};

	const setValue = value => {
		// Number type
		if (newInput?.valueType === 'number') {
			setNewInput({
				...newInput,
				value: parseFloat(value)
			});
			return;
		}
		// Boolean types
		if (newInput?.valueType === 'boolean' && value === 'true') {
			setNewInput({
				...newInput,
				value: true
			});
			return;
		}
		if (newInput?.valueType === 'boolean' && value === 'false') {
			setNewInput({
				...newInput,
				value: false
			});
			return;
		}
		setNewInput({
			...newInput,
			value
		});
	};

	return (
		<div style={{
			marginLeft: '1em',
		}}>
			<BasicButton
				color='white'
				text={label}
				onClick={() => setNewMain(true)}
				backgroundColor={{
					backgroundColor: getSecondary(),
					border: `1px solid ${getSecondary()}`,
					boxShadow: 'none',
					color: 'white',
					fontWeight: 'bold',
					height: '30px',
					width: '145px',
				}}
			/>
			<AlertConfirm
				open={newMain}
				title={'Valores de la opcion'}
				buttonAccept={translate.save}
				buttonCancel={translate.cancel}
				cancelAction={() => {
					setNewInput(input);
					setNewMain(false);
				}}
				hideAccept={Object.keys(error).length > 0}
				acceptAction={() => {
					setLocalState({ ...newInput });
					setNewMain(false);
				}}
				requestClose={() => setNewMain(true)}
				bodyStyle={{ minWidth: '60vw' }}
				bodyText={
					<div
						style={{
							display: 'flex', flexDirection: 'column', rowGap: '1em'
						}}
					>
						{/* INPUT TYPE */}
						<div style={{
							border: `2px solid ${getPrimary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getPrimary(),
								fontSize: '18px'
							}}>
								Tipo de input
							</span>
							<br/>
							{/* INPUT TYPE */}
							{inputTypes
							&& <div
								style={{
									display: 'flex', justifyContent: 'space-evenly'
								}}
							>
								{inputTypes.map(inputType => (
									<Radio
										key={inputType.value}
										styleLabel={{ margin: '0' }}
										name="inputType"
										label={inputType.label}
										value={inputType.value}
										checked={type === inputType.value}
										onChange={event => setType(event.target.value)}
									/>
								))}
							</div>}
						</div>
						{/* INPUT NAME */}
						<div style={{
							border: `2px solid ${getSecondary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getSecondary(),
								fontSize: '18px'
							}}>
								Nombre del campo
							</span>
							<TextInput
								floatingText={'Nombre'}
								onChange={event => setName(event.nativeEvent.target.value)}
								errorText={error.name}
								value={newInput.name}
							/>
						</div>
						<div style={{
							border: `2px solid ${getPrimary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getPrimary(),
								fontSize: '18px'
							}}>
								Tipo de valor
							</span>
							<br/>
							{/* VALUE TYPE */}
							{valueTypes
							&& <div
								style={{
									display: 'flex', justifyContent: 'space-evenly'
								}}
							>
								{valueTypes.map(valueType => (
									<Radio
										key={valueType.value}
										styleLabel={{ margin: '0' }}
										name="valueType"
										label={valueType.label}
										value={valueType.value}
										checked={newInput?.valueType === valueType.value}
										onChange={event => setNewInput({
											...newInput,
											valueType: event.target.value
										})}
									/>
								))}
							</div>}
						</div>
						{/* DEFAULT VALUE */}
						<div style={{
							border: `2px solid ${getSecondary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getSecondary(),
								fontSize: '18px'
							}}>
								Valor inicial
							</span>
							<TextInput
								floatingText={'Valor inicial'}
								onChange={event => setValue(event.nativeEvent.target.value)}
								value={newInput.value}
							/>
						</div>
						{/* OPTIONAL CHECKBOX OPTIONS */}
						{newInput.type === 'checkbox'
						&& <div style={{
							border: `2px solid ${getSecondary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getSecondary(),
								fontSize: '18px'
							}}>
								Opciones mínimas seleccionadas
							</span>
							<TextInput
								floatingText={'Valor inicial'}
								onChange={event => setMinSelections(parseFloat(event.nativeEvent.target.value))}
								errorText={error?.minSelections}
								value={newInput.minSelections}
							/>
						</div>}
						{newInput.type === 'checkbox'
						&& <div style={{
							border: `2px solid ${getSecondary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getSecondary(),
								fontSize: '18px'
							}}>
								Opciones máximas seleccionadas
							</span>
							<TextInput
								floatingText={'Valor inicial'}
								onChange={event => setMaxSelections(parseFloat(event.nativeEvent.target.value))}
								errorText={error?.maxSelections}
								value={newInput.maxSelections}
							/>
						</div>}
						{newInput.type === 'textarea'
						&& <div style={{
							border: `2px solid ${getSecondary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getSecondary(),
								fontSize: '18px'
							}}>
								Límite de caracteres
							</span>
							<TextInput
								floatingText={'Límite de caracteres'}
								onChange={event => setMaxSize(parseFloat(event.nativeEvent.target.value))}
								errorText={error?.maxSize}
								value={newInput.maxSize}
							/>
						</div>}
						{/* TRANSLATIONS */}
						<div style={{
							border: `2px solid ${getPrimary()}`,
							padding: '4px',
						}}>
							<span style={{
								color: getPrimary(),
								fontSize: '18px'
							}}>
								Clave de traducción
							</span>
							<TextInput
								floatingText={'Label'}
								onChange={event => {
									setNewInput({
										...newInput,
										label: event.nativeEvent.target.value
									});
								}}
								value={newInput.label}
							/>
							<div>
								Traducción: {translate[newInput.label] ? translate[newInput.label] : '*No funciona la key o está mal escrita'}
							</div>
						</div>
						<div style={{
							border: `2px solid ${getSecondary()}`,
							padding: '4px',
							marginTop: '4px'
						}}>
							<span style={{
								color: getSecondary(),
								fontSize: '18px'
							}}>
								Traducción personalizada por idioma
							</span>
							{Object.keys(newInput.text).map(key => (
								<TextInput
									key={key}
									floatingText={key}
									value={newInput.text[key]}
									onChange={event => {
										setNewInput({
											...newInput,
											text: {
												...newInput.text,
												[key]: event.nativeEvent.target.value
											}
										});
									}
									}
								/>
							))}
						</div>

					</div>
				}
			/>
		</div>
	);
};


export default ModalNewInput;

